<template>
    <div
        :class="{'no-campaign': emptyState.type, 'has-trial-alert': hasTrialAlert}"  
        class="empty-state d-flex justify-content-center align-items-center py-3">
        <Icon :icon="emptyState.icon"/>
        <div v-if="emptyState.texts && !$route.query.filters">
            <div class="no-request"  v-for="text in emptyState.texts" :key="text" v-html="text"/>
        </div>
        <div v-else>
            <p class="first">
                {{ emptyState.emptyStateTitle}}
            </p>
            <p v-if="$route.query.filters">
                No matching results for your search criteria.
            </p>
            <div>
                <p>
                    {{ emptyState.emptyStateDesc }}
                </p>
                <router-link 
                    v-if="emptyState.emptyStateButtonText" 
                    :id="emptyState.type && emptyState.type ==='noCampaign' ? 'add-campaign-button-dashboard' : ''"
                    :to="emptyState.routeTo">
                    <Button
                        :id="emptyState.type && emptyState.type ==='noCampaign' ? 'add-campaign-button-dashboard' : ''"
                        @click.native = "trackEvent"
                        type="emptyState">
                            {{ emptyState.emptyStateButtonText }}
                    </Button>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Theme/Icon'
import Button from '../Button'
import useEmptyState from './useEmptyState'
import {useStore, useRouter} from '../../../../core/hooks'
import {computed} from '@vue/composition-api'
export default {
    name: 'EmptyState',
    components: {
        Icon,
        Button
    },
    setup(props, {root}) {
        const { emptyState } = useEmptyState()
        const {store} = useStore()
        const hasTrialAlert = computed(() => store.getters.hasTrial && !store.getters.membershipStatus)

        const trackEvent = () => {

            if(!emptyState.value.routeTo.startsWith('/wizard')) return

            root.$sendMixpanelEvent('Add Wizard Opened', {
                Location: 'Dashboard'
            })
            root.$ga.event('Add Wizard', 'Page Opened', 'Location', 'Dashboard')
        }

        return {
            emptyState,
            trackEvent,
            hasTrialAlert
        }
    }
    
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables.scss';
div.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    &.no-campaign {
        height: calc(100vh - 135px);

        &.has-trial-alert {
            height: calc(100vh - 225px);
        }
    }

    div.no-request {
        color: $c3;
        font-size: $p3;
        line-height: 24px;
    }
    
    p {
        color: $c3;
        font-size: $p3;
        margin-bottom: 27px;
        
        &.first {
            font-weight: $weight_bold;
            margin-top: 32px;
            margin-bottom: 0;
        }   
    }

}
</style>